import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function listScenarios() {
  const { data } = await axios.get(`${API}/scenarios`);
  return data;
}

export async function saveScenario(payload) {
  const { data } = await axios.post(`${API}/scenarios`, payload);
  return data;
}

export async function deleteScenario(id) {
  const { data } = await axios.delete(`${API}/scenarios/${id}`);
  return data;
}

export async function fetchUsgsRecent() {
  const { data } = await axios.get(`${API}/usgs/recent`);
  return data;
}
